import { IExportColumnModel } from "../../../../../shared/models";

export const FeatureFlagsColumnList: IExportColumnModel[] = [
]